import { Button } from "primereact/button";
import extractDataFromMap from "../../utils/ExtractDataFromMap";
import { format as dateFnsFormat } from "date-fns";
import { Tag } from "primereact/tag";
import { Image } from "primereact/image";

const genTemplateBodyAction = ({ row, onEdit, onDelete }) => {
  return (
    <div className="row-center-center gap-2">
      {onEdit && (
        <Button
          icon="pi pi-pencil"
          rounded
          severity="success"
          className="bg-emerald-400 max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            if (onEdit) onEdit(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
      )}
      {onDelete && (
        <Button
          icon="pi pi-trash"
          rounded
          severity="danger"
          className="bg-red-400 max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            if (onDelete) onDelete(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
      )}
    </div>
  );
};

const genTemplateBodyText = ({ row, field, defaultEmpty }) => {
  const rowDataValue = extractDataFromMap({
    key: field,
    map: row,
  });

  return rowDataValue;
};

const genTemplateBodyBooleanStatus = ({
  row,
  statusLabelMap = { 1: "Online", 0: "Offline" },
  statusSeverityMap = { 1: "success", 0: "danger", default: "secondary" },
}) => {
  const status = row.status;
  const label =
    status in statusLabelMap
      ? statusLabelMap[status]
      : statusLabelMap["default"] || "Unknown";
  const severity =
    status in statusSeverityMap
      ? statusSeverityMap[status]
      : statusSeverityMap["default"] || "secondary";

  return (
    <div className="row-center-center gap-2">
      <Tag
        value={label}
        severity={severity}
        className="max-w-[5rem] max-h-[1.85rem]"
      />
    </div>
  );
};

const genRetribusiTemplateBodyAction = ({
  row,
  onChangeDate,
  onChangeStatus,
  onPayment,
}) => {
  return (
    <div className="row-center-center gap-2">
      {onChangeDate && (
        <Button
          icon="pi pi-calendar"
          rounded
          severity="success"
          className="max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            if (onChangeDate) onChangeDate(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
      )}
      {onChangeStatus && (
        <Button
          icon="pi pi-list-check"
          rounded
          severity="info"
          className="max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            if (onChangeStatus) onChangeStatus(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
      )}
      {onPayment && (
        <Button
          icon="pi pi-dollar"
          rounded
          severity="danger"
          className="max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            if (onPayment) onPayment(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
      )}
    </div>
  );
};

const genTemplateBodyNumber = ({
  row,
  field,
  defaultEmpty,
  maxFraction,
  minFraction,
}) => {
  const rowDataValue = extractDataFromMap({
    key: field,
    map: row,
  });

  return rowDataValue
    ? rowDataValue.toLocaleString("id-ID", {
        maximumFractionDigits: maxFraction ?? 2,
        minimumFractionDigits: minFraction ?? 0,
      })
    : defaultEmpty
    ? ""
    : 0;
};

const genTemplateBodyDate = ({ row, field, format }) => {
  const rowDataValue = extractDataFromMap({
    key: field,
    map: row,
  });

  if (!rowDataValue) return "";

  const dateObject = new Date(rowDataValue);
  const _format = format ?? "dd/MM/yyyy";

  return dateFnsFormat(dateObject, _format);
};

const genTemplateBodyDateTime = ({ row, field, format }) => {
  const rowDataValue = extractDataFromMap({
    key: field,
    map: row,
  });

  if (!rowDataValue) return "";

  const dateObject = new Date(rowDataValue);
  const _format = format ?? "dd/MM/yyyy HH:mm";

  return dateFnsFormat(dateObject, _format);
};

const genTemplateBodyImage = ({ row, field, preview = false }) => {
  const rowDataValue = extractDataFromMap({
    key: field,
    map: row,
  });
  if (rowDataValue && rowDataValue !== null) {
    if (preview) {
      return (
        <Image
          src={`${rowDataValue}`}
          alt={rowDataValue}
          width="64"
          preview
          imageClassName="shadow-2 border-round"
        />
      );
    }
    return (
      <img
        src={`${rowDataValue}`}
        alt={rowDataValue}
        className="shadow-2 border-round"
        style={{ width: "64px" }}
      />
    );
  } else {
    return "";
  }
};

export {
  genRetribusiTemplateBodyAction,
  genTemplateBodyAction,
  genTemplateBodyText,
  genTemplateBodyNumber,
  genTemplateBodyDate,
  genTemplateBodyDateTime,
  genTemplateBodyImage,
  genTemplateBodyBooleanStatus
};
